// src/pages/Moderation/ModerationQueueDetailsPage/ui/ModeratorDecisionCard/ModeratorDecisionCard.tsx
import classNames from 'classnames';
import { SmallLoader } from 'components/SmallLoader';
import React from 'react';
import './ModeratorDecisionCard.scss';

type Props = {
  loader: boolean;
  btnActive: 'approve' | 'reject' | '';
  report: any;

  approved?: boolean | null;
  moderatedAt?: string | null;
  moderatorId?: number | null;

  onApprove: () => void;
  onReject: () => void;
};

export const ModeratorDecisionCard: React.FC<Props> = ({
  loader,
  btnActive,
  report,
  approved,
  moderatedAt,
  moderatorId,
  onApprove,
  onReject,
}) => {
  const status = approved === true ? 'Approved' : approved === false ? 'Rejected' : 'On moderation';

  return (
    <section className="md-card" role="group" aria-label="Moderator decision">
      <header className="md-card__header">
        <h3 className="md-card__title">Moderator decision</h3>
        <span
          className={classNames('md-card__status', {
            'md-card__status--ok': approved === true,
            'md-card__status--bad': approved === false,
            'md-card__status--wait': approved == null,
          })}
        >
          {status}
        </span>
      </header>

      <div className="md-card__meta">
        <div className="md-card__meta-row">
          <span className="md-card__meta-k">Restricted:</span>
          <span className="md-card__meta-v">{report?.restricted ? 'Yes' : 'No'}</span>
        </div>
        <div className="md-card__meta-row">
          <span className="md-card__meta-k">Restriction code:</span>
          <span className="md-card__meta-v">{report?.restriction ?? '—'}</span>
        </div>
        <div className="md-card__meta-row">
          <span className="md-card__meta-k">Moderated at:</span>
          <span className="md-card__meta-v">{moderatedAt || '—'}</span>
        </div>
        <div className="md-card__meta-row">
          <span className="md-card__meta-k">Moderator id:</span>
          <span className="md-card__meta-v">{moderatorId ?? '—'}</span>
        </div>
      </div>

      <div className="md-card__actions">
        <button
          className={classNames('md-btn', 'md-btn--approve', { block: approved === true })}
          onClick={onApprove}
          disabled={approved === true}
        >
          {loader && btnActive === 'approve' ? (
            <SmallLoader height={14} width={14} />
          ) : (
            '✅ Approve'
          )}
        </button>

        <button
          className={classNames('md-btn', 'md-btn--reject', { block: approved === false })}
          onClick={onReject}
          disabled={approved === false}
        >
          {loader && btnActive === 'reject' ? <SmallLoader height={14} width={14} /> : '❌ Reject'}
        </button>
      </div>

      <div className="md-card__hint">Approve = content violates rules. Reject = content is OK.</div>
    </section>
  );
};
